<div class="close-btn-outer">
    <button mat-mini-fab color="warn" (click)="close()"><mat-icon>close</mat-icon></button>
</div>
<div mat-dialog-content>
  <div fxLayoutAlign="center center">
    <h3 class="downloadAppH3">К сожалению покупка товара на сайте на данный момент ограничена.</h3>
  </div>
  <div fxLayoutAlign="center center">
    <h3 class="downloadAppH3">Вы можете приобрести товар в нашем приложении.</h3>
  </div>
  <div fxLayout="row wrap" class="downloadAppFrame" >
    <div fxFlex="100" fxFlex.gt-sm="50" fxLayoutAlign="center center">
      <div>
        <a class="logo" href="https://apps.apple.com/ru/app/thaicos/id1383219094" ><img src="assets/images/appStore.png" class="logoImg"></a>
      </div>
    </div>
    <div fxFlex="100" fxFlex.gt-sm="50" fxLayoutAlign="center center" ngClass.gt-sm="px-2 m-0" ngClass.sm="mt-2" ngClass.xs="mt-2">
      <div>
        <a class="logo" href="https://play.google.com/store/apps/details?id=com.kg.thaicos&hl=ru"><img src="assets/images/googleMarket.png" class="logoImg"></a>
      </div>
    </div>
  </div>
</div>
